import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AuraVisionChat from './vision/AuraVisionChat';
import ErrorBoundary from './common/ErrorBoundary';

const EnhancedVisionAIAssistant = ({
  vision,
  user,
  onAdviceGenerated,
  onStrategyUpdated,
  cashflowData: _cashflowData,
  portfolioData: propPortfolioData,
  achievementStrategy,
}) => {
  const [portfolioData, setPortfolioData] = useState(propPortfolioData || null);
  const [boundaryKey, setBoundaryKey] = useState(0);

  useEffect(() => {
    if (propPortfolioData) {
      setPortfolioData(propPortfolioData);
      return;
    }
    const load = async () => {
      try {
        const response = await axios.get('/api/portfolio/summary');
        if (response.data?.success) {
          setPortfolioData(response.data);
        }
      } catch (error) {
        console.error('[EnhancedVisionAIAssistant] portfolio load:', error);
      }
    };
    load();
  }, [propPortfolioData]);

  const handleStrategyUpdated = (card) => {
    onStrategyUpdated?.(card);
    onAdviceGenerated?.(card);
  };

  if (!vision?.vision_id) {
    return (
      <div className="min-h-[400px] flex items-center justify-center p-6 surface-panel">
        <p className="text-body text-secondary">Select a Vision to open the AI assistant.</p>
      </div>
    );
  }

  return (
    <div className="h-full min-h-[600px] flex flex-col surface-panel p-4 md:p-5">
      <ErrorBoundary
        name="AuraVisionChat"
        title="Something went wrong — retry"
        onReset={() => setBoundaryKey((k) => k + 1)}
      >
        <AuraVisionChat
          key={`${vision.vision_id}-${boundaryKey}`}
          vision={vision}
          user={user || { user_id: vision.user_id || 'unknown' }}
          portfolioData={portfolioData}
          achievementStrategy={achievementStrategy ?? vision?.achievement_strategy ?? null}
          onStrategyUpdated={handleStrategyUpdated}
        />
      </ErrorBoundary>
    </div>
  );
};

export default EnhancedVisionAIAssistant;
